export default __webpack_public_path__ + "static/media/delet.00bd2c75.svg";